<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules", :class="formItemClass")
  prjIdSelect(ref="prjIdSelect", :format="options.format", :vFormMode="vFormMode", v-model="fieldModel", @changeProject="changeProject", v-bind="prjBind")
    //- @getPrjOptions="getPrjOptions",
</template>

<script>
import { staticMixins, mapVFAssignField } from "@/CommonDP/VForm/utils";
import prjIdSelect from "./prjIdSelect.vue";

export default {
  components: { prjIdSelect },
  mixins: [staticMixins],
  computed: {
    ...mapVFAssignField("prjName", "prjCode"),
    prjBind() {
      return {
        disabled: !this.isEdit
      };
    },
    vmDefaultValue() {
      return this.prjId;
    }
  },
  methods: {
    changeProject(val) {
      this.prjName = val?.prjName || "";
      this.prjCode = val?.prjCode || "";
      this.emitValidate();
    }
  }
};
</script>
